module.exports = {"survey-10-resource-1":{"resourceId":1,"surveyId":10,"date":"31.12.2017","time":"before 4 pm","vehicleTypeId":null,"trailer":true,"packer":0,"fitter":1,"porter":0},"survey-10-resource-2":{"resourceId":2,"surveyId":10,"date":"day before move","time":"13:00","vehicleTypeId":null,"trailer":false,"packer":2,"fitter":0,"porter":0}}


//////////////////
// WEBPACK FOOTER
// ./src/data/Resources.json
// module id = 480
// module chunks = 4